import classNames from 'classnames';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import InputLabel, { InputLabelSize } from '../../atoms/InputLabel/InputLabel';
import InputTextArea from '../../atoms/InputTextArea/InputTextArea';
import InputTextAreaCount from '../../atoms/InputTextAreaCount/InputTextAreaCount';
import InputValidationFeedback from '../../atoms/InputValidationFeedback/InputValidationFeedback';

interface IInputTextAreaLabel {
  autoFocus?: boolean;
  capitalizeLabel?: boolean;
  className?: string;
  disabled?: boolean;
  inputLabelSize?: InputLabelSize;
  invalidMessage?: string;
  isValid?: boolean;
  maxLength?: number;
  noResize?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  title: string;
  validMessage?: string;
  value: string;
}

const InputTextAreaLabel = ({
  autoFocus,
  capitalizeLabel = false,
  className,
  disabled = false,
  invalidMessage,
  isValid,
  inputLabelSize,
  maxLength,
  noResize = true,
  onBlur = () => {},
  onChange,
  onFocus = () => {},
  onKeyPress = () => {},
  placeholder,
  required = false,
  rows,
  title,
  validMessage,
  value,
}: IInputTextAreaLabel) => {
  const inputTextAreaLabelClasses = classNames(
    'm-input-text-area-label',
    className,
  );

  const inputLabelClasses = classNames(
    'mb-2',
    { 'text-capitalize': capitalizeLabel },
  );

  const inputId = uuidv4();

  return (
    <div
      data-test="m-input-text-area-label"
      className={inputTextAreaLabelClasses}
    >
      <InputLabel
        className={inputLabelClasses}
        data-test="m-input-text-area-label__input-label"
        htmlFor={inputId}
        size={inputLabelSize}
        required={required}
      >
        {title}
      </InputLabel>

      <InputTextArea
        autoFocus={autoFocus}
        disabled={disabled}
        data-test="m-input-text-area-label__input-text-area"
        id={inputId}
        isValid={isValid}
        maxLength={maxLength}
        noResize={noResize}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        rows={rows}
        value={value}
      />

      <div className={`mt-1 w-100 d-flex justify-content-between`}>
        <InputValidationFeedback
          data-test="m-input-text-area-label__input-validation-feedback"
          invalidMessage={invalidMessage}
          isValid={isValid}
          validMessage={validMessage}
        />
        { maxLength ? (
          <InputTextAreaCount
            maxLength={maxLength}
            value={value}
          />
        ) : null}
      </div>

    </div>
  );
};

export default InputTextAreaLabel;
